/* eslint-disable max-len */
import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { NbDialogService } from '@nebular/theme';
import { take } from 'rxjs/operators';
import { SharedService } from 'src/app/shared/services/shared.service';
import { User } from '../models/users.model';
import { DialogComponent } from '../shared/ui/dialog/dialog.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  user: User;

  constructor(
    private ss: SharedService,
    private dialogService: NbDialogService,
    private afs: AngularFirestore,
  ) {}

  async ngOnInit() {
    this.user = await this.ss.getUser();
    this.checkUserAgreedToTerms();
  }

  async checkUserAgreedToTerms() {
    if (!this.user.agreedToTerms) {
      const result = await this.openTsAndCsModal();
      if (result === 'confirm') {
        this.afs.doc<User>(`users/${this.user.uid}`).update({ agreedToTerms: true });
      }
    }
  }

  async openTsAndCsModal() {
    return await this.dialogService
      .open(DialogComponent, {
        closeOnBackdropClick: false,
        context: {
          title: 'POPI Updates',
          body: `
          We have updated our policies and procedures in line with the Protection of Personal Information (POPI) Act.
          <br /> <br />
          Please take note of the following in this regard:
          <br /> <br />
          <ul>
            <li>By virtue of the agreement which exists between SWIFT CSV and you, the Client, certain personal information is required to carry out the contracted service and as such the Client has, by accepting the Terms & Conditions when signing up, given SWIFT CSV consent to use such relevant personal information. Personal information will only be used for the explicit, specific and lawful rendering of the required service.</li>
            <li>In line with requirements of POPI, all personal information will be safeguarded and stored in a secure environment.</li>
            <li>SWIFT CSV hereby asserts that no information will ever be divulged or sold to 3rd parties for the purposes of direct marketing.</li>
            <li>No 3rd party service providers have access to our data base or any form of personal information pertaining to our clients.</li>
            <li>All data is currently stored on our servers which are protected by high levels of cyber protection.</li>
            <li>The Client is responsible to keep personal information updated on the SWIFT CSV system as SWIFT CSV cannot access any of the above as it is protected by The Client managed username and password.</li>
            <li>The Client is aware that SWIFT CSV uses personal information, such the email address and contact number, to communicate with the Client. Communications include but are not limited to the results of converted documents, newsletters, information on new services, reminders, etc.</li>
            <li>The Client is responsible to manage his/her own subscription on the SWIFT CSV website, to use the DELETE function on the Statement History, once the conversion of a PDF statement was completed, to permanently remove all traces of such statements from the SWIFT CSV system.</li>
          </ul>
          <br />
          Should you have any queries regarding the above, please do not hesitate to contact us on admin@swiftcsv.com.
          <br /> <br />
          For more information please see our full
          <a
            href="https://firebasestorage.googleapis.com/v0/b/swift-csv-prod.appspot.com/o/static_files%2FSwift%20CSV%20PAIA%20Manual.pdf?alt=media&token=348cbeb8-386b-4b21-bfe3-ec2d74cc1cdd"
            target="_blank">
            Terms and Conditions
          </a>
                `,
          cancel: ``,
          confirm: `Accept`,
          confirmClickDelay: 600,
        },
      })
      .onClose.pipe(take(1))
      .toPromise();
  }
}
